import {Component, OnInit, Input, ElementRef, Output, EventEmitter, ChangeDetectionStrategy} from '@angular/core';
import {LoggerService} from '../services/logger/logger.service';

@Component({
  selector: 'app-ny-table',
  templateUrl: './ny-table.component.html',
})
export class NyTableComponent implements OnInit {


  @Input() title: any;

  @Input() columns: any;

  @Input() data: any;

  @Input() rows: any;

  @Output() rowSelect: EventEmitter<any> = new EventEmitter<any>();


  constructor(private loggerService: LoggerService,
              private ele: ElementRef
  ) {
  }

  ngOnInit() {
  }




  onSelectionChange(table, event) {
    this.rowSelect.emit(event);
  }
}
